import React, { useRef, useState } from 'react'
import customImageComponent from '../../../common/CustomImageComponent'
import { StepTitle } from './StepTitle'
import { IconCheck } from '../../../icons/IconCheck'

import { IHorseData } from '../../../../models/horse/horse.interface'
import { IRider } from '../../../../types/entryRider'

interface IProps {
  horses: IHorseData[]
  newHorse: IHorseData | null
  selectHandler: (itm: IHorseData) => void
  rider: IRider
  selectedRiderMultiHorse: IHorseData | null
  setSelectedRiderMultiHorse: (itm: IHorseData) => void
  isMultiHorseShown: boolean
}
const CHECKED_ICON = 'assets/cp_icons/Ok-3.svg'

export const SelectNewHorse: React.FC<IProps> = ({
  horses,
  selectHandler,
  newHorse,
  rider,
  isMultiHorseShown,
  selectedRiderMultiHorse,
  setSelectedRiderMultiHorse,
}) => {
  const searchBoxRef = useRef<HTMLInputElement>(null)
  const [searchValue, setSearchValue] = useState('')
  const [listToShow, setListToShow] = useState<IHorseData[]>([])

  React.useEffect(() => {
    if (newHorse) {
      setSearchValue(newHorse.horseName || '')
      filterHorses(newHorse.horseName || '')
    }
  }, [])

  const handleHorses = (strToSearch: string) => {
    if (strToSearch === '') {
      setListToShow(horses)
    }
    const matched = horses.filter((horse) => {
      return horse?.horseName?.toLowerCase().includes(strToSearch.toLowerCase())
    })

    setListToShow(matched)
  }

  const filterHorses = (strToSearch: string) => {
    setSearchValue(strToSearch)
    handleHorses(strToSearch)
  }
  return (
    <>
      <StepTitle
        title={
          rider.horsesSelected && rider.horsesSelected.length < 2
            ? 'Select new horse to switch'
            : 'Which horse are you swapping out?'
        }
        desc={''}
      />

      {!isMultiHorseShown ? (
        <>
          <div className="inputSearch flex items-center relative">
            <input
              ref={searchBoxRef}
              type="text"
              onChange={(e) => filterHorses(e.target.value)}
              value={searchValue}
              placeholder="Search horse name"
              className="rounded-full w-full border focus:border-[#D3DAEE] border-[#D3DAEE] text-SeabiscuitDark200ThemeColor focus:ring-0"
            />
          </div>

          <div className="mt-5">
            {searchValue &&
              listToShow[0] &&
              listToShow.map((horse) => {
                const selected = newHorse && newHorse.id === horse.id
                return (
                  <div
                    onClick={() => selectHandler(horse)}
                    key={horse.id}
                    className="form-check mb-3 cursor-pointer"
                  >
                    <div className="user flex items-center rounded-lg py-1 w-full justify-between">
                      <div className="min-w-fit flex items-center">
                        {customImageComponent(
                          horse.horseProfilePicture,
                          horse.horseName,
                          'w-[40px] min-w-[40px] h-[40px] rounded-full mr-2 avatarImg object-cover'
                        )}
                        <div className="hourseDetails w-10/12">
                          <div className="hourseTitle text-SeabiscuitDark200ThemeColor">
                            <p className="text-SeabiscuitDark200ThemeColor text-lg capitalize">
                              {horse.horseName}
                            </p>
                          </div>
                        </div>
                      </div>

                      {selected ? (
                        <img
                          src={CHECKED_ICON}
                          className="relative right-[0px] top-[0px]"
                          width={20}
                          height={20}
                          alt="checked"
                        />
                      ) : null}
                    </div>
                  </div>
                )
              })}
          </div>
        </>
      ) : (
        <ul className={'list-none m-0 p-0 flex flex-col gap-3'}>
          {rider.horsesSelected?.map((item) => {
            const horse = horses.find((horse) => horse.id === item.id)
            if (!horse) return null
            return (
              <li
                key={horse.horseId}
                className={'flex items-center gap-2 justify-between text-black cursor-pointer'}
                onClick={() => setSelectedRiderMultiHorse(horse)}
              >
                <div className={'flex items-center gap-2'}>
                  <span>
                    {customImageComponent(
                      horse.horseProfilePicture,
                      horse.horseName,
                      'w-[45px] h-[45px] avatarImg rounded-full object-cover border'
                    )}
                  </span>
                  <span>{horse.horseName}</span>
                </div>
                <div
                  className={`border-[2px]  border-solid border-[${selectedRiderMultiHorse && selectedRiderMultiHorse.id === horse.id ? '#00b6aa' : '#122B4680'}] rounded-[100%] w-[24px] h-[24px] flex items-center justify-center`}
                >
                  {selectedRiderMultiHorse && selectedRiderMultiHorse.id === horse.id && (
                    <IconCheck color={'text-[#00b6aa]'} />
                  )}
                </div>
              </li>
            )
          })}
        </ul>
      )}
    </>
  )
}
